"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import { EmailWithoutDocuments } from "./email_without_documents";
import { emailService } from "../services/email_service";
import DataStoreService from "./data_store_service";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { maybePrefetchNextFlowModeItem } from "./flow_mode/flow_mode_service";
function sendEmail(params) {
  return ApiService.addErrorHandler(
    // TODO: use fetch instead
    // eslint-disable-next-line no-restricted-syntax
    $.post("/api/email_messages", params).then(function(r) {
      return DataStoreService.updateStores(r.data);
    }),
    null,
    { caller: "EmailPage.sendEmail" }
  );
}
function returningMethods(props) {
  return {
    sendEmail,
    onComplete: () => onComplete(props)
  };
}
function onComplete(props) {
  ToDashboardWithFilters(props.location);
}
class EmailPage extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      isLoaded: false
    });
    __publicField(this, "setCarrier", (carrierEvent) => {
      return $.post(
        "/api/email_messages/" + this.state.email.id + "/set_carrier",
        {
          carrier_id: carrierEvent.carrierId
        }
      ).then((data) => {
        this.setState((prevState) => ({
          email: __spreadValues(__spreadValues({}, prevState.email), data.email_message)
        }));
        return DataStoreService.updateStores(data);
      });
    });
  }
  componentDidMount() {
    var id = this.props.params.id;
    emailService.getWithId(id, true).then((email) => {
      var parent = email.parent;
      if (parent) {
        const exceptions = _.some(parent.exceptioned_items, function(item) {
          return item.state !== "complete";
        });
        const exceptionedItem = exceptions[0];
        if (exceptionedItem) {
          if (exceptionedItem.owner_type == "DocumentGroup") {
            $.get("/api/document_groups/" + exceptionedItem.owner_id).then(
              (data) => {
                this.setState({
                  email,
                  parent,
                  documentGroup: data.document_group,
                  isLoaded: true
                });
              }
            );
            return;
          }
        }
      }
      this.setState({
        email,
        parent,
        isLoaded: true
      });
    });
    maybePrefetchNextFlowModeItem(this.props.location);
  }
  render() {
    if (this.state.isLoaded) {
      return /* @__PURE__ */ jsx(
        "div",
        {
          "data-component": "EmailPage",
          className: "row general-container reply-container",
          children: /* @__PURE__ */ jsx(
            EmailWithoutDocuments,
            {
              documentGroup: this.state.documentGroup,
              email: this.state.email,
              location: this.props.location,
              returningMethods: returningMethods(this.props),
              carrierSetter: { onSetCarrier: this.setCarrier }
            }
          )
        }
      );
    } else {
      return /* @__PURE__ */ jsx("div", {});
    }
  }
}
export default EmailPage;
